import styled from 'styled-components';

const AdminTeamsWrap = styled.div`
  display: flex;
  flex: 12;
  background-color: ${props => props.theme.tableBgColor};
  overflow-y: scroll;

  &.table {
    flex-direction: column;
  }
  ::-webkit-scrollbar {
    width: 0; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }
`;
export const AdminTeamFormWrap = styled.div`
  display: flex;
  flex: 12;
  flex-direction: column;
  background-color: ${props => props.theme.tableBgColor};
  &.form-footer {
    border-radius: 0 0 5px 5px;

    @media screen and (max-width: 767px) {
      flex-direction: column;
    }
  }

  &.admin-chests {
    flex-direction: column;
  }

  &.team-form {
    flex-direction: row;

    @media screen and (max-width: 767px) {
      flex-direction: column-reverse;
    }
  }
  ::-webkit-scrollbar {
    width: 0; /* Remove scrollbar space */
    background: transparent; /* Optional: just make scrollbar invisible */
  }
`;

export default AdminTeamsWrap;
